import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Tooltip } from 'react-tippy'

export default class Insight extends Component {
  static propTypes = {
    children: PropTypes.any,
    content: PropTypes.string,
    position: PropTypes.string,
    willShow: PropTypes.bool.isRequired,
  }

  constructor() {
    super()
    this.state = {
      showTooltip: false,
    }
  }

  componentDidMount() {
    this.mounted = true
    setTimeout(() => {
      if(this.mounted) this.setState({showTooltip: true})
      setTimeout(() => {
        if(this.mounted) this.setState({showTooltip: false})
      }, 6500)
    }, 1500)
  }

  componentWillUnmount() {
    this.mounted = false
  }

  render() {
    const { showTooltip } = this.state
    const { children, content, position, willShow } = this.props
    return (
      <Tooltip
        title={content}
        position={position || 'top'}
        trigger="manual"
        disabled={!showTooltip}
        open={willShow && showTooltip}
        arrow
        sticky
      >
        {children}
      </Tooltip>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/renderPropComponents/Insight.js